<template>
    <div class="unsubscribe-page">
        <!-- ========================================== -->
        <!-- 1. МОБИЛЬНАЯ ВЕРСИЯ (< 1264px)             -->
        <!-- ========================================== -->
        <div class="d-sm-block d-mb-block d-lg-none" v-if="isMobile">
            <div class="main-container-mobile">
                <div class="lang-switch-wrapper-mobile">
                    <div class="lang-switch-container">
                        <button 
                            type="button" 
                            class="lang-btn" 
                            :class="{ active: currentLang === 'ru' }" 
                            @click="setLanguage('ru')"
                        >
                            RU
                        </button>
                        <span class="lang-divider">|</span>
                        <button 
                            type="button" 
                            class="lang-btn" 
                            :class="{ active: currentLang === 'kz' }" 
                            @click="setLanguage('kz')"
                        >
                            KZ
                        </button>
                    </div>
                </div>

                <div class="foreground-container-mobile">
                    <div class="first-block-mobile px-4">
                        <img 
                            src="@/assets/img/absolut-age-confirm-logo.svg" 
                            alt="Absolut Tabasco" 
                            class="absolut-logo-mobile mb-6" 
                        />

                        <!-- Состояние загрузки -->
                        <div v-if="isLoadingForm" class="form-loading py-10">
                            <v-progress-circular indeterminate size="56" color="#ffffff" />
                        </div>

                        <!-- Состояние ошибки -->
                        <div v-else-if="hasError" class="error-container text-center py-6 px-4">
                            <h4 class="title-text-mobile mb-3">{{ $t('unsubscribe.loadErrorTitle') }}</h4>
                            <p class="error-desc mb-6">{{ errorMessage || $t('unsubscribe.loadErrorText') }}</p>
                            <button @click="fetchPreferences" class="btn-confirm-mobile">
                                {{ $t('common.retry') }}
                            </button>
                        </div>

                        <!-- Форма отписки -->
                        <div v-else class="w-100">
                            <h4 class="title-text-mobile unsubscribe-title-mobile">
                                {{ $t('unsubscribe.title') }}
                            </h4>
                            
                            <div class="checkboxes-container-mobile">
                                <label class="checkbox-row">
                                    <input
                                        type="checkbox"
                                        v-model="form.doNotBulkEmail"
                                        class="checkbox-native"
                                        @change="handleIndividualChange"
                                    />
                                    <span class="custom-checkbox"></span>
                                    <span class="checkbox-label">
                                        {{ $t('unsubscribe.doNotBulkEmail') }}
                                    </span>
                                </label>

                                <label class="checkbox-row">
                                    <input
                                        type="checkbox"
                                        v-model="form.doNotEmail"
                                        class="checkbox-native"
                                        @change="handleIndividualChange"
                                    />
                                    <span class="custom-checkbox"></span>
                                    <span class="checkbox-label">
                                        {{ $t('unsubscribe.doNotEmail') }}
                                    </span>
                                </label>

                                <label class="checkbox-row">
                                    <input
                                        type="checkbox"
                                        v-model="form.doNotSendMm"
                                        class="checkbox-native"
                                        @change="handleAllCommChange"
                                    />
                                    <span class="custom-checkbox"></span>
                                    <span class="checkbox-label">
                                        {{ $t('unsubscribe.doNotSendMm') }}
                                    </span>
                                </label>
                            </div>

                            <button 
                                @click="savePreferences" 
                                class="btn-confirm-mobile mt-4 mb-6" 
                                :disabled="isSaving"
                            >
                                {{ isSaving ? $t('unsubscribe.savingBtn') : $t('unsubscribe.submitBtn') }}
                            </button>
                        </div>
                    </div>

                    <div class="second-block-mobile">
                        <img 
                            src="@/assets/img/absolut-age-confirm-mobile-img.png" 
                            alt="Absolut Tabasco" 
                            class="absolut-bottle-mobile" 
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- ========================================== -->
        <!-- 2. ДЕСКТОП ВЕРСИЯ (>= 1264px)              -->
        <!-- ========================================== -->
        <div class="d-none d-lg-block d-xl-block d-xxl-block" v-else>
            <div class="main-container">
                <div class="lang-switch-wrapper-desktop">
                    <div class="lang-switch-container">
                        <button 
                            type="button" 
                            class="lang-btn" 
                            :class="{ active: currentLang === 'ru' }" 
                            @click="setLanguage('ru')"
                        >
                            RU
                        </button>
                        <span class="lang-divider">|</span>
                        <button 
                            type="button" 
                            class="lang-btn" 
                            :class="{ active: currentLang === 'kz' }" 
                            @click="setLanguage('kz')"
                        >
                            KZ
                        </button>
                    </div>
                </div>

                <img src="@/assets/img/age-confirm-bg-1.png" alt="Background" class="background-image" />

                <div class="foreground-container">
                    <div class="first-block">
                        <img 
                            src="@/assets/img/absolut-age-confirm-logo.svg" 
                            alt="Absolut Tabasco" 
                            class="absolut-logo-desktop mb-6" 
                        />

                        <!-- Состояние загрузки -->
                        <div v-if="isLoadingForm" class="form-loading py-10">
                            <v-progress-circular indeterminate size="64" color="#ffffff" />
                        </div>

                        <!-- Состояние ошибки -->
                        <div v-else-if="hasError" class="error-container text-center py-6 px-6">
                            <h4 class="title-text mb-3">{{ $t('unsubscribe.loadErrorTitle') }}</h4>
                            <p class="error-desc mb-6">{{ errorMessage || $t('unsubscribe.loadErrorText') }}</p>
                            <button @click="fetchPreferences" class="btn-confirm">
                                {{ $t('common.retry') }}
                            </button>
                        </div>

                        <!-- Форма отписки -->
                        <div v-else class="first-block text-left">
                            <h4 class="title-text unsubscribe-title">
                                {{ $t('unsubscribe.title') }}
                            </h4>
                            
                            <div class="checkboxes-container">
                                <label class="checkbox-row">
                                    <input
                                        type="checkbox"
                                        v-model="form.doNotBulkEmail"
                                        class="checkbox-native"
                                        @change="handleIndividualChange"
                                    />
                                    <span class="custom-checkbox"></span>
                                    <span class="checkbox-label">
                                        {{ $t('unsubscribe.doNotBulkEmail') }}
                                    </span>
                                </label>

                                <label class="checkbox-row">
                                    <input
                                        type="checkbox"
                                        v-model="form.doNotEmail"
                                        class="checkbox-native"
                                        @change="handleIndividualChange"
                                    />
                                    <span class="custom-checkbox"></span>
                                    <span class="checkbox-label">
                                        {{ $t('unsubscribe.doNotEmail') }}
                                    </span>
                                </label>

                                <label class="checkbox-row">
                                    <input
                                        type="checkbox"
                                        v-model="form.doNotSendMm"
                                        class="checkbox-native"
                                        @change="handleAllCommChange"
                                    />
                                    <span class="custom-checkbox"></span>
                                    <span class="checkbox-label">
                                        {{ $t('unsubscribe.doNotSendMm') }}
                                    </span>
                                </label>
                            </div>

                            <button 
                                @click="savePreferences" 
                                class="btn-confirm mt-6 mb-4" 
                                :disabled="isSaving"
                            >
                                {{ isSaving ? $t('unsubscribe.savingBtn') : $t('unsubscribe.submitBtn') }}
                            </button>
                        </div>
                    </div>

                    <div class="second-block">
                        <img 
                            src="@/assets/img/age-confirm-main-img.png" 
                            alt="Absolut Tabasco" 
                            class="absolut-bottle-desktop" 
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- Уведомления (Snackbar) -->
        <v-snackbar v-model="snackbar" timeout="4000" class="btn-contaiener" bottom center>
            {{ message }}
            <template v-slot:action="{ attrs }">
                <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
                    {{ $t('common.close') }}
                </div>
            </template>
        </v-snackbar>
    </div>
</template>

<style scoped>
/* ---------------------------------------- Языковой переключатель */
.lang-switch-wrapper-desktop {
    position: absolute;
    top: 24px;
    right: 32px;
    z-index: 1001;
    display: flex;
    justify-content: flex-end;
}

.lang-switch-wrapper-mobile {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: max(16px, env(safe-area-inset-top, 16px)) 20px 10px 20px;
    box-sizing: border-box;
    z-index: 1001;
}

.lang-switch-container {
    display: inline-flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 18px;
    padding: 2px 4px;
    gap: 2px;
    backdrop-filter: blur(4px);
}

.lang-btn {
    background: transparent;
    border: none;
    outline: none;
    font-family: var(--font-family-bold, "MontserratBold", sans-serif);
    font-size: 11px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.85);
    padding: 3px 8px;
    border-radius: 14px;
    cursor: pointer;
    line-height: 1.1;
    letter-spacing: 0.5px;
    transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.lang-btn:hover {
    color: #FFFFFF;
}

.lang-btn.active {
    background: #FFFFFF;
    color: var(--color-primary, #DD1814);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.lang-divider {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.4);
    user-select: none;
}

/* ---------------------------------------- Desktop main styles */
.main-container {
    position: relative;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background-color: #0b0b0b;
}

.background-image {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
    z-index: 1;
    transform: scaleX(-1);
}

.foreground-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1000;
    color: #ffffff;
    font-size: 24px;
    gap: 90px;
    width: 100%;
    max-width: 1300px;
    padding: 0 40px;
    box-sizing: border-box;
}

.first-block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-shrink: 0;
    max-width: 580px;
    width: 100%;
}

.first-block.text-left {
    text-align: left;
    width: 100%;
}

.absolut-logo-desktop {
    max-width: 320px;
    width: 100%;
    height: auto;
    display: block;
}

.second-block {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 520px;
    max-height: 80vh;
    flex: 1;
}

.absolut-bottle-desktop {
    max-width: 100%;
    max-height: 75vh;
    width: auto;
    height: auto;
    object-fit: contain;
}

.title-text {
    margin-bottom: 0px;
    font-family: var(--font-family-bold, "MontserratBold", sans-serif);
    font-weight: 700;
    font-size: 26px;
    line-height: 1.3;
    color: var(--color-white, #ffffff);
}

.unsubscribe-title {
    margin-top: 0;
    margin-bottom: 24px;
    font-size: 24px;
    line-height: 1.35;
    text-align: left;
    color: #ffffff;
}

.checkboxes-container,
.checkboxes-container-mobile {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
}

/* ---------------------------------------- Чекбоксы */
.checkbox-row {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    cursor: pointer;
    user-select: none;
    text-align: left;
    position: relative;
}

.checkbox-native {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
    pointer-events: none;
}

.custom-checkbox {
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    border: 2px solid #FFFFFF;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1px;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.checkbox-row:hover .custom-checkbox {
    border-color: #FFFFFF;
    background-color: rgba(255, 255, 255, 0.15);
}

.checkbox-native:checked + .custom-checkbox {
    background-color: #FFFFFF;
    border-color: #FFFFFF;
}

.checkbox-native:checked + .custom-checkbox::after {
    content: "";
    width: 6px;
    height: 11px;
    border: solid #DD1814;
    border-width: 0 2.5px 2.5px 0;
    transform: rotate(45deg);
    margin-bottom: 2px;
}

.checkbox-label {
    font-family: var(--font-family, "MontserratRegular", sans-serif);
    font-size: 15px;
    line-height: 1.45;
    color: #FFFFFF;
    margin: 0;
    cursor: pointer;
}

/* ---------------------------------------- Кнопки */
.btn-confirm {
    border-radius: 8px;
    padding: 14px 38px;
    min-height: 54px;
    color: var(--color-primary, #DD1814);
    font-family: var(--font-family-bold, "MontserratBold", sans-serif);
    font-weight: 800;
    font-size: 17px;
    letter-spacing: 1px;
    text-transform: uppercase;
    background: #ffffff;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
    transition: all 0.3s ease;
}

.btn-confirm:hover {
    background: #f5f5f5;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.5);
}

.btn-confirm:active {
    transform: translateY(1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
}

.btn-confirm:disabled,
.btn-confirm-mobile:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

/* ---------------------------------------- Mobile styles */
.main-container-mobile {
    position: relative;
    width: 100vw;
    min-height: 100vh;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    overflow-x: hidden;
    background-color: #0b0b0b;
}

.main-container-mobile::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('../assets/img/absolut-age-confirm-bg-mobile.png');
    background-size: cover;
    background-position: center;
    transform: scaleX(-1);
    z-index: 0;
    pointer-events: none;
}

.foreground-container-mobile {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1000;
    color: #ffffff;
    width: 100%;
    flex: 1;
    box-sizing: border-box;
}

.first-block-mobile {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 480px;
}

.absolut-logo-mobile {
    width: 260px;
    max-width: 80vw;
    height: auto;
    display: block;
}

.title-text-mobile {
    margin-bottom: 0px;
    font-family: var(--font-family-bold, "MontserratBold", sans-serif);
    color: var(--color-white, #ffffff);
    font-size: 18px;
    line-height: 1.3;
    text-align: center;
    font-weight: 700;
}

.unsubscribe-title-mobile {
    margin-top: 0;
    margin-bottom: 18px;
    font-size: 17px;
    line-height: 1.35;
    text-align: center;
}

.checkboxes-container-mobile {
    display: flex;
    flex-direction: column;
    text-align: left;
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    gap: 16px;
}

.btn-confirm-mobile {
    border-radius: 8px;
    padding: 13px 28px;
    width: 100%;
    max-width: 320px;
    min-height: 50px;
    color: var(--color-primary, #DD1814);
    font-family: var(--font-family-bold, "MontserratBold", sans-serif);
    font-weight: 800;
    font-size: 16px;
    letter-spacing: 1px;
    text-transform: uppercase;
    background: #ffffff;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
    transition: all 0.3s ease;
}

.btn-confirm-mobile:hover {
    background: #f5f5f5;
    transform: translateY(-2px);
}

.btn-confirm-mobile:active {
    transform: translateY(1px);
}

.second-block-mobile {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-top: auto;
    padding-top: 10px;
}

.absolut-bottle-mobile {
    max-width: 220px;
    width: 60%;
    height: auto;
    display: block;
    object-fit: contain;
}

/* ---------------------------------------- Error & Loading */
.error-container {
    background: rgba(221, 24, 20, 0.12);
    border: 1px solid rgba(221, 24, 20, 0.6);
    border-radius: 12px;
    max-width: 480px;
    margin: 0 auto;
    color: #ffffff;
    backdrop-filter: blur(8px);
}

.error-desc {
    font-family: var(--font-family, "MontserratRegular", sans-serif);
    font-size: 14px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.9);
}

.form-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

/* ---------------------------------------- Snackbar */
.snackbar-btn {
    color: #ff5252;
    font-family: var(--font-family-bold, "MontserratBold", sans-serif);
    font-size: 0.875rem;
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;
    padding: 8px 12px;
}
</style>

<script>
export default {
    name: "UnsubscribeView",
    data() {
        return {
            isMobile: window.innerWidth < 1264,
            snackbar: false,
            message: "",
            isLoadingForm: true,
            isSaving: false,
            hasError: false,
            errorMessage: "",
            form: {
                doNotSendMm: false,
                doNotEmail: false,
                doNotBulkEmail: false
            }
        };
    },
    computed: {
        leadId() {
            return this.$route.params.leadId;
        },
        currentLang() {
            return this.$i18n.locale;
        }
    },
    methods: {
        setLanguage(lang) {
            this.$i18n.locale = lang;
            localStorage.setItem("userLang", lang);
        },

        handleResize() {
            this.isMobile = window.innerWidth < 1264;
        },

        handleAllCommChange() {
            if (this.form.doNotSendMm) {
                this.form.doNotEmail = true;
                this.form.doNotBulkEmail = true;
            }
        },

        handleIndividualChange() {
            if (!this.form.doNotEmail || !this.form.doNotBulkEmail) {
                this.form.doNotSendMm = false;
            }
        },

        async fetchPreferences() {
            if (!this.leadId) {
                this.hasError = true;
                this.errorMessage = this.$t('unsubscribe.userNotFound');
                this.isLoadingForm = false;
                return;
            }

            this.isLoadingForm = true;
            this.hasError = false;
            this.errorMessage = "";

            try {
                const response = await this.$http.get(`/api/lead/${this.leadId}/communication`);
                const data = response.data || {};

                this.form = {
                    doNotSendMm: !!data.doNotSendMm,
                    doNotEmail: !!data.doNotEmail,
                    doNotBulkEmail: !!data.doNotBulkEmail
                };
            } catch (e) {
                console.error("Ошибка загрузки настроек коммуникаций:", e);
                this.hasError = true;
                if (e.response && e.response.status === 404) {
                    this.errorMessage = this.$t('unsubscribe.userNotFound');
                } else {
                    this.errorMessage = this.$t('unsubscribe.loadErrorText');
                }
            } finally {
                this.isLoadingForm = false;
            }
        },

        async savePreferences() {
            if (!this.leadId) {
                this.message = this.$t('unsubscribe.userNotFound');
                this.snackbar = true;
                return;
            }

            this.isSaving = true;

            try {
                await this.$http.put(`/api/lead/${this.leadId}/communication`, this.form);
                this.message = this.$t('unsubscribe.successMessage');
                this.snackbar = true;
            } catch (e) {
                console.error("Ошибка сохранения настроек:", e);
                this.message = this.$t('unsubscribe.errorMessage');
                this.snackbar = true;
            } finally {
                this.isSaving = false;
            }
        }
    },
    mounted() {
        this.fetchPreferences();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }
};
</script>